import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from './icon';
import { StyledH1 } from './_shared/styled-headings';
import { StyledSection } from './_shared/styled-section';

const StyledTextSection = styled.section`
  white-space: pre-line;
`;
const StyledFeatureGridContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 0.5rem;
  margin-top: 0.5rem;
  width: 100%;
`;
const StyledFeatureCard = styled.article`
  ${'' /* border: 1px solid var(--body-color); */}
  border-radius: var(--radius);
  background-color: #1b1d2a;
  display: flex;
  ${'' /* align-items: center; */}
  text-align: left;
  flex-direction: column;
  min-height: 250px;
  width: 1000px;
  padding: 1.2rem;
  box-sizing: border-box;

  & svg {
    height: 2rem;
    width: 2rem;
    font-size: 2rem;
  }
`;
const StyledCardLabel = styled.h2`
  display: flex;
  align-items: center;
  font-size: 1.13rem;
  margin: 1rem 0;
  color: var(--body-color);
  width: 800px;
`;
const StyledDivider = styled.div`
  width: 15%;
  height: 2px;
  background-color: var(--primary-color);
  margin-bottom: 1rem;
`;
const StyledFeatureDescription = styled.p`
  font-size: 0.8rem;
`;

const Workex = ({ cards, description, title, id = null }) => {
  return (
    <>
      <div id="workex">
        <StyledSection id={id}>
          {title && <StyledH1> Work Experience </StyledH1>}
          <StyledTextSection dangerouslySetInnerHTML={{ __html: description }} />
          <StyledFeatureGridContainer>
            <StyledFeatureCard>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src="/icons/swiftbaLogo.png" width={60} height={60} />
                <StyledCardLabel>
                  <a href="https://app.swiftba.com/" target="_blank" style={{ marginRight: '20px' }}>
                    {'SwiftBa'}
                  </a>
                  {'(1-May-23 to 1-Oct-23)'}
                </StyledCardLabel>
                <a
                  href="https://app.swiftba.com/"
                  target="_blank"
                  rel="noopener"
                  title="Demo Link"
                  style={{ margin: '20px 20px 0 0' }}
                >
                  <Icon icon="external-link-alt" />
                </a>
              </div>
              <h6 style={{ marginTop: '0px', marginBottom: '20px' }}> Position: Founding Frontend Engineer</h6>
              <StyledDivider> </StyledDivider>
              <StyledFeatureDescription>
                <ul>
                  <li>
                    Single‐handedly planned and developed the frontend for a Business Analytics AI Meeting Tool, leading
                    the entire process from planning to deployment.
                  </li>
                  <li>Scaled the frontend, ensuring its scalability, performance and maintainability.</li>
                  <li>Assisted the backend devs in identifying, testing, and resolving critical bugs.</li>
                  <li>Conducted comprehensive analysis of Figma designs, reporting technical and logical gaps.</li>
                  <li>
                    Scalable Practices:‐ CodeSplitting , Dynamic injection of reducers, global scss colors, mixins,
                    typography.
                  </li>
                </ul>
              </StyledFeatureDescription>
            </StyledFeatureCard>
            <StyledFeatureCard>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src="/icons/toddle.png" width={60} height={60} />
                <StyledCardLabel>
                  <a href="https://www.toddleapp.com/" target="_blank" style={{ marginRight: '20px' }}>
                    {'Toddle'}
                  </a>
                  {'(3-Jan-22 to 1-Oct-22)'}
                </StyledCardLabel>
                <a
                  href="https://web.toddleapp.com/"
                  target="_blank"
                  rel="noopener"
                  title="Demo Link"
                  style={{ margin: '20px 20px 0 0' }}
                >
                  <Icon icon="external-link-alt" />
                </a>
              </div>
              <h6 style={{ marginTop: '0px', marginBottom: '20px' }}> Position: Associate Software Engineer</h6>
              <StyledDivider> </StyledDivider>
              <StyledFeatureDescription>
                <ul>
                  <li>
                    Integral part of the team responsible for developing generic react component and pages for student
                    progress reports and Transcripts.
                  </li>
                  <li>
                    Shipped features like academic year and term manager , transcripts (landing page, list, and history
                    page), developed multiple tables that had hierarchical and nested data and much more.
                  </li>
                  <li>Analyzed the Figma design of the assigned feature/module for technical gaps.</li>
                  <li>Learned the skill and value of writing clean , structured, and generic code.</li>
                  <li>Documented every major feature and module added by me.</li>
                  <li>Enhanced my skills in React , Redux Thunk , HOC , GraphQL , JavaScript, clean code, and SCSS.</li>
                  <li>
                    Resolved numerous medium‐level bugs/issues that arose on a daily basis, also some Sentry issues.
                  </li>
                  <li>Reduced the number of received review comments on my MR from 50+ to 0.</li>
                  <li>Raised 120+ Merge Requests, Reviewed 5‐10 MRs.</li>
                </ul>
              </StyledFeatureDescription>
            </StyledFeatureCard>
            <StyledFeatureCard>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src="/icons/ets.jpg" width={60} height={60} />
                <StyledCardLabel>
                  <a style={{ marginRight: '20px', cursor: 'default', color: '#f1b631' }}>
                    {'Edunomics Tech Solution'}
                  </a>
                  (7-June-21 to 1-Aug-21)
                </StyledCardLabel>
                <a
                  href="https://memomeet.onrender.com/"
                  target="_blank"
                  rel="noopener"
                  title="Demo Link"
                  style={{ margin: '20px 20px 0 0' }}
                >
                  <Icon icon="external-link-alt" />
                </a>
              </div>
              <h6 style={{ marginTop: '0px', marginBottom: '20px' }}> Position: MERN Web-Developer</h6>
              <StyledDivider> </StyledDivider>
              <StyledFeatureDescription>
                <ul>
                  <li>Worked as a Sole MERN Developer.</li>
                  <li>
                    Independently designed and developed an online meeting recorder , including a Landing‐Page, Web‐App,
                    and Chrome‐Extension.
                  </li>
                  <li>Users can record meetings via the extension and watch them in the web app.</li>
                  <li>
                    Incorporated NLP technology(developed by a senior), to return transcription, summary, and PPT of the
                    meeting in the Web‐App.
                  </li>
                  <li>
                    Features:‐ developed notes app associated with each recording, authentication
                    (login/logout/sign‐up), Reset/Forgot Password , and CRUD operations on notes and recordings.
                  </li>
                </ul>
              </StyledFeatureDescription>
            </StyledFeatureCard>
          </StyledFeatureGridContainer>
        </StyledSection>
      </div>
    </>
  );
};

Workex.propTypes = {
  cards: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.string,
  title: PropTypes.string,
};

export default Workex;
